/** Prefer module modal roots so portaled dialogs inherit module-scoped CSS. */

export function getSalonModalRoot() {
  if (typeof document === 'undefined') return null;
  return document.getElementById('ny-salon-modal-root') || document.body;
}

export function getEnterpriseSalonModalRoot() {
  if (typeof document === 'undefined') return null;
  return document.getElementById('enterprise-salon-modal-root') || document.body;
}

export function getNaturalsSalonModalRoot() {
  if (typeof document === 'undefined') return null;
  return document.getElementById('naturals-salon-modal-root') || document.body;
}
